import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { IModules } from "../../../../models/IUser";
import {
  updateItemWithModified,
  resetModified,
  filterModified,
  WithModified,
  deepClone,
} from "../utils/modifiedFields";

const MAX_CHILD_MODULES = 10;

export function useChildModulesState(
  module: IModules | null,
  modules: IModules[],
  markMutated: () => void,
) {
  const [childModulesState, setChildModulesState] = useState<
    WithModified<IModules>[]
  >([]);

  const childModulesToDisplay = module
    ? modules.filter(
        (el) => (el.parent_id ?? el.parent_module_id) === module.id,
      )
    : [];

  useEffect(() => {
    setChildModulesState(
      childModulesToDisplay.map((childModule) => ({
        ...deepClone(childModule),
        __modified: [],
      })),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modules, module?.id]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    moduleId?: number | null,
    moduleIndex?: number,
  ) => {
    markMutated();
    const { name, value } = e.target;

    setChildModulesState((prevList) =>
      prevList.map((childModule, idx) => {
        const matchById = moduleId != null && childModule.id === moduleId;
        const matchByIndex = moduleIndex != null && idx === moduleIndex;
        return matchById || matchByIndex
          ? updateItemWithModified(childModule, name, value)
          : childModule;
      }),
    );
  };

  const addChildSlot = () => {
    if (childModulesState.length >= MAX_CHILD_MODULES) {
      toast.error(
        `Максимальное количество дочерних модулей: ${MAX_CHILD_MODULES}`,
      );
      return;
    }

    markMutated();
    const newSlot: WithModified<IModules> = {
      id: undefined as unknown as number,
      serial: "",
      charge_id: "",
      limit_A: "",
      limit_B: "",
      limit_C: "",
      plant_id: module?.plant_id ?? 0,
      line_id: module?.line_id ?? 0,
      device_type: "smb",
      parent_id: module?.id ?? null,
      parent_module_id: module?.id ?? null,
      "Line.name": "",
      "Line.id": 0,
      __modified: ["__new"],
    };
    setChildModulesState((prev) => [...prev, newSlot]);
  };

  const reset = () => {
    setChildModulesState((prev) => prev.map(resetModified));
  };

  const modifiedChildModules = filterModified(childModulesState).filter(
    (item) => !(item.id == null && !item.charge_id),
  );

  return {
    childModulesState,
    handleChange,
    addChildSlot,
    reset,
    modifiedChildModules,
  };
}
